export const OPTIONS_LANGUAGES = [
  { name: "Français", value: "fr" },
  { name: "English", value: "en" },
];
